import { render, staticRenderFns } from "./ibItemDev.vue?vue&type=template&id=8185b2ea&"
import script from "./ibItemDev.vue?vue&type=script&lang=js&"
export * from "./ibItemDev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports